import  ShopCategoriesList from './ShopCategoriesList';
export default ShopCategoriesList
